import { useEffect, useState } from "react";
import { Menu, Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Header } from "antd/es/layout/layout";
import { Link, useLocation } from "react-router-dom"; // Importe o useLocation
import "./MenuComponent.css";

// ... (Interfaces permanecem as mesmas)
interface MenuItem {
  id: number
  nome: string
  link: string
  ordem: number
  ativo: boolean
  submenus?: MenuItem[]
}

interface MenuComponentProps {
  estruturaCompleta: any
}

export default function MenuComponent({ estruturaCompleta }: MenuComponentProps) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);
  
  // Hook do React Router para saber a página atual
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (estruturaCompleta && estruturaCompleta.menus) {
      processarMenus(estruturaCompleta.menus);
    }
  }, [estruturaCompleta]);

  const processarMenus = (menusData: any[]) => {
    // ... (Sua lógica de processar os menus continua a mesma)
    try {
     setLoading(true)

     const menusProcessados = menusData
       .map((menu: any) => ({
         id: menu.id_menu,
         nome: menu.nome,
         link: menu.link_pagina || "#",
         ordem: menu.ordem || 0,
         ativo: menu.ativo,
         submenus:
           menu.submenus?.map((sub: any) => ({
             id: sub.id_submenu,
             nome: sub.descricao,
             link: sub.link_pagina,
             ordem: sub.ordem,
             ativo: sub.ativo,
           })) || [],
       }))
       .sort((a, b) => a.ordem - b.ordem)

     setMenus(menusProcessados)
   } catch (error) {
     console.error("Erro ao processar menus:", error)
     setMenus([
       { id: 1, nome: "Home", link: "/", ordem: 1, ativo: true },
       { id: 2, nome: "Produtos", link: "/produtos", ordem: 2, ativo: true },
       { id: 3, nome: "Catálogos", link: "/catalogos", ordem: 3, ativo: true },
       { id: 4, nome: "Vídeos", link: "/videos", ordem: 4, ativo: true },
     ])
   } finally {
     setLoading(false)
   }
  };

  const renderMenuItem = (item: MenuItem) => {
    if (item.submenus && item.submenus.length > 0) {
      return (
        <Menu.SubMenu key={item.link} title={item.nome} popupClassName="submenu-dropdown">
          {item.submenus.map((submenu) => (
            <Menu.Item key={submenu.link}>
              <Link to={submenu.link} onClick={() => isMobile && setDrawerVisible(false)}>
              <span style={{color: '#fff',}}>
                {submenu.nome}

              </span>
              </Link>
            </Menu.Item>
          ))}
        </Menu.SubMenu>
      );
    }
    return (
      <Menu.Item key={item.link}>
        <Link to={item.link} onClick={() => isMobile && setDrawerVisible(false)}>
          {item.nome}
        </Link>
      </Menu.Item>
    );
  };
  
  // Encontra a chave do menu que corresponde à rota atual
  const getSelectedKey = () => {
    const currentPath = location.pathname;
    // Tenta encontrar uma correspondência exata primeiro
    let bestMatch = menus.find(menu => menu.link === currentPath);
    if (bestMatch) return bestMatch.link;

    // Se não encontrar, busca pelo início da rota (ex: /produtos/tintas corresponde a /produtos)
    const parentMatch = menus.find(menu => currentPath.startsWith(menu.link) && menu.link !== '/');
    return parentMatch ? parentMatch.link : currentPath;
  }

  // ADICIONE ESTE OBJETO DE ESTILO
  const headerStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    zIndex: 1000, // Garante que fique acima de tudo
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // Adicione padding ou box-shadow se quiser melhorar o visual
    boxShadow: '0 2px 8px #f0f1f2' 
  };

  if (loading) {
    return <Header className="app-header" style={headerStyle} />;
  }

  return (
    <Header className="app-header" style={headerStyle}>
      {isMobile ? (
        <>
          <Button
            type="text"
            icon={<MenuOutlined style={{ color: "#fff", fontSize: 24 }} />}
            onClick={() => setDrawerVisible(true)}
          />
          <div className="logo-container">
            <Link to="/">
              <img src="/logo.png" alt="Logo" />
            </Link>
          </div>
          <Drawer title="Menu" placement="left" onClose={() => setDrawerVisible(false)} open={drawerVisible}>
            <Menu mode="vertical" selectedKeys={[getSelectedKey()]}>
              {menus.map((item) => renderMenuItem(item))}
            </Menu>
          </Drawer>
        </>
      ) : (
        <>
          <div className="logo-container">
            <Link to="/">
              <img src="/logo.png" alt="DURAFIX Logo" />
            </Link>
          </div>
          <div className="menu-container">
            <Menu
              theme="dark"
              mode="horizontal"
              className="main-menu"
              selectedKeys={[getSelectedKey()]}
              triggerSubMenuAction="hover"
            >
              {menus.map((item) => renderMenuItem(item))}
            </Menu>
          </div>
        </>
      )}
    </Header>
  );
}